import api from './api'

export const sectionService = {
  // 사용자의 모든 구간 조회
  async getUserSections() {
    try {
      const response = await api.get('/section/user')
      return response.data
    } catch (error) {
      console.error('사용자 구간 조회 실패:', error)
      throw error
    }
  },

  // 특정 곡의 사용자 구간 조회
  async getUserSongSections(songId) {
    try {
      const response = await api.get(`/section/user/song/${songId}`)
      return response.data
    } catch (error) {
      console.error('곡별 구간 조회 실패:', error)
      throw error
    }
  },

  // 구간 생성
  async createSection(sectionData) {
    try {
      console.log('구간 생성 요청 데이터:', sectionData)
      const response = await api.post('/section', {
        songId: sectionData.songId,
        type: sectionData.type || 1, // SectionType.Repeat 기본값
        name: sectionData.name,
        startTime: sectionData.startTime,
        endTime: sectionData.endTime,
        lyrics: sectionData.lyrics || null,
        pronunciation: sectionData.pronunciation || null,
        description: sectionData.description || null
      })
      return response.data
    } catch (error) {
      console.error('구간 생성 실패:', error)
      throw error
    }
  },

  // 구간 수정
  async updateSection(sectionId, sectionData) {
    try {
      console.log('구간 수정 요청 데이터:', { sectionId, sectionData })
      await api.put(`/section/${sectionId}`, {
        type: sectionData.type,
        name: sectionData.name,
        startTime: sectionData.startTime,
        endTime: sectionData.endTime,
        lyrics: sectionData.lyrics || null,
        pronunciation: sectionData.pronunciation || null,
        description: sectionData.description || null,
        lineNumber: sectionData.lineNumber || null,
        isPublic: sectionData.isPublic || false
      })
    } catch (error) {
      console.error('구간 수정 실패:', error)
      throw error
    }
  },

  // 구간 삭제
  async deleteSection(sectionId) {
    try {
      await api.delete(`/section/${sectionId}`)
    } catch (error) {
      console.error('구간 삭제 실패:', error)
      throw error
    }
  },

  // 연습 횟수 증가
  async incrementPracticeCount(sectionId) {
    try {
      await api.post(`/section/${sectionId}/practice`)
    } catch (error) {
      console.error('연습 횟수 증가 실패:', error)
      throw error
    }
  },

  // 구간 상세 조회
  async getSection(sectionId) {
    try {
      const response = await api.get(`/section/${sectionId}`)
      return response.data
    } catch (error) {
      console.error('구간 조회 실패:', error)
      throw error
    }
  },

  // 구간 데이터를 localStorage와 동기화
  async syncWithLocalStorage() {
    try {
      // localStorage의 구간 데이터
      const localSections = JSON.parse(localStorage.getItem('ttaechang_saved_sections') || '[]')

      if (localSections.length === 0) {
        return { synced: 0, uploaded: 0 }
      }

      let uploadCount = 0

      // 각 로컬 구간을 서버에 업로드 시도
      for (const localSection of localSections) {
        try {
          // songId는 YouTube ID에서 Songs 테이블 ID로 매핑 필요
          // 현재는 임시로 1을 사용 (실제로는 songId 매핑 로직 필요)
          await this.createSection({
            songId: 1, // TODO: YouTube ID -> Songs 테이블 ID 매핑
            name: localSection.name,
            startTime: localSection.start,
            endTime: localSection.end,
            description: `${localSection.songTitle} - ${localSection.songArtist}`
          })
          uploadCount++
        } catch (error) {
          console.warn('구간 업로드 실패:', localSection.name, error)
        }
      }

      return { synced: localSections.length, uploaded: uploadCount }
    } catch (error) {
      console.error('구간 동기화 실패:', error)
      throw error
    }
  },

  // 서버에서 구간 데이터를 가져와 localStorage에 저장
  async loadFromServer() {
    try {
      const serverSections = await this.getUserSections()

      // 서버 구간을 localStorage 형식으로 변환
      const localSections = serverSections.map(section => ({
        id: section.id,
        name: section.name,
        start: section.startTime,
        end: section.endTime,
        songId: `server_${section.songId}`, // 서버 구간 식별자
        songTitle: section.songTitle || 'Unknown',
        songArtist: section.songArtist || 'Unknown',
        createdAt: section.createdAt,
        isServerSection: true
      }))

      // 기존 localStorage 구간과 합치기
      const existingLocal = JSON.parse(localStorage.getItem('ttaechang_saved_sections') || '[]')
      const combined = [...existingLocal, ...localSections]

      localStorage.setItem('ttaechang_saved_sections', JSON.stringify(combined))

      return { loaded: serverSections.length, total: combined.length }
    } catch (error) {
      console.error('서버 구간 로드 실패:', error)
      throw error
    }
  },

  // 가사 전용 조회
  async getUserSongLyrics(songId) {
    try {
      const response = await api.get(`/section/user/song/${songId}/lyrics`)
      return response.data
    } catch (error) {
      console.error('가사 조회 실패:', error)
      throw error
    }
  },

  // 구간반복 전용 조회
  async getUserSongRepeats(songId) {
    try {
      const response = await api.get(`/section/user/song/${songId}/repeats`)
      return response.data
    } catch (error) {
      console.error('구간반복 조회 실패:', error)
      throw error
    }
  },

  // 가사 섹션 생성
  async createLyricsSection(sectionData) {
    try {
      const response = await api.post('/section', {
        songId: sectionData.songId,
        type: 2, // SectionType.Lyrics
        name: sectionData.name,
        startTime: sectionData.startTime,
        endTime: sectionData.endTime,
        lyrics: sectionData.lyrics,
        pronunciation: sectionData.pronunciation || null,
        description: sectionData.description || null,
        lineNumber: sectionData.lineNumber || null,
        isPublic: sectionData.isPublic || false
      })
      return response.data
    } catch (error) {
      console.error('가사 섹션 생성 실패:', error)
      throw error
    }
  }
}